import { useEffect, useState } from 'react'
import { DownloadFilesButton } from 'lib/components/download-assets-button/download-assets-button'
import { DownloadCurrentVersionResponse, fetchDownloadableFiles } from 'lib/api/tickets/tickets'
import { Loader2 } from 'lucide-react'
import { haveFiles } from 'lib/ticket/utils'

interface DownloadFilesProps {
  ticketId: number | bigint
  subject: string
  currentVersion: number
  ticketFilesCount: number | bigint
}

export default function DownloadFiles({ ticketId, subject, currentVersion, ticketFilesCount }: DownloadFilesProps) {
  const [downloadableFiles, setDownloadableFiles] = useState<DownloadCurrentVersionResponse['data'] | null>(null)
  const downloadDate = new Date().toLocaleDateString().replaceAll('/', '')
  const version = currentVersion === 0 ? '' : `_V${currentVersion}`
  const downloadZipName = `${ticketId}_${subject}_${downloadDate}${version}`

  useEffect(() => {
    const fetchTicketDownloadableFiles = async () => {
      const files = await fetchDownloadableFiles(Number(ticketId))
      setDownloadableFiles(files)
    }
    fetchTicketDownloadableFiles()
  }, [ticketId])

  if (downloadableFiles == null) {
    return (
      <div className="min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center">
        <Loader2 className="tw-animate-spin" />
      </div>
    )
  }

  return (
    <div className="min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-10">
      <h4 className="tw-mb-4 tw-text-2xl tw-font-bold">{subject}</h4>
      {haveFiles(ticketFilesCount) && downloadableFiles?.length > 0 ? (
        <DownloadFilesButton
          files={downloadableFiles}
          buttonColor="transparent"
          buttonText="Download Files"
          className="tw-rounded tw-bg-blue-600 tw-px-6 tw-py-3 tw-text-white hover:tw-bg-blue-700"
          zipName={downloadZipName}
        />
      ) : (
        <div className="tw-align-middle tw-text-lg tw-text-gray-500">No files available for download.</div>
      )}
    </div>
  )
}
